/*eslint-disable*/
import {commonApi, common} from '@/common/index'

const gamePageBanner = {
  data() {
    return {
      // 其他页面
      banner: '',
      bannerLink: '',

      // 首页轮播
      indexBannerList: [],
      indexBannerLinkList: []
    }
  },
  computed: {
    mySwiper(){
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    getBannerList() {
      commonApi.HOMEBEFORE.fetchImg(this.bannerCode)
        .then((list) => {
          this.banner = list[0].imgLink;
          this.bannerLink = list[0].imgClickLink;
          // 首页轮播
          this.indexBannerList = list;
          this.initIndexBannerLinkList()
        })
        .catch(err => {})
    },
    initIndexBannerLinkList() {
      if(this.indexBannerList.length>0){
        let arr = [];
        this.indexBannerList.forEach((item)=>{
          arr.push(item.imgClickLink)
        });
        // 将第一个链接添加到最后，对应swiper复制到最后一个
        this.indexBannerLinkList = [...arr,arr[0]];
      }
    },
    indexBannerGoHref(e) {
      console.log(666666)
      if(e.target.tagName.toLowerCase()!=='img') return;

      let index = this.mySwiper.activeIndex-1;
      let link = this.indexBannerLinkList[index];

      console.log( this.indexBannerLinkList[index])
      this.goBannerHref(link)
    },
    goBannerHref(url) {
      if(!url) return;

      let path = common.goHref(url);
      if(path) {
        this.$router.push({path})
      }
    }
  },
  mounted() {
    this.bannerCode&&this.getBannerList()
  }
};
export default gamePageBanner



// WEBPACK FOOTER //
// ./src/common/mixins/banner-codeImg/bannerCodeImg.js